// datoteka: src/Components/UserDashboard/MobileFavoriteAdCard.js
import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, IconButton, Chip, Stack } from '@mui/material';
import { Visibility, Delete, PhotoCamera } from '@mui/icons-material'; // Zamenjamo Edit z Visibility

const MobileFavoriteAdCard = ({ item, onDelete, getImageUrl, getStatusClass, navigateToAd, isSelected, onSelectToggle }) => {
    const primaryImage = item.images?.find(img => img.is_primary) || item.images?.[0];
    const imageUrl = getImageUrl(primaryImage?.image_url, 'card', { text: "Oglas" });

    return (
        <Card onClick={onSelectToggle} sx={{ display: 'flex', mb: 2, width: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', border: isSelected ? '2px solid #463CE5' : 'none', cursor: 'pointer' }}>
            <Box
                onClick={(e) => { e.stopPropagation(); navigateToAd(); }}
                sx={{ width: 100, height: 100, flexShrink: 0, m: 1, borderRadius: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', backgroundColor: '#f0f0f0' }}
            >
                {primaryImage ? (
                    <CardMedia component="img" sx={{ width: '100%', height: '100%', objectFit: 'cover' }} image={imageUrl} alt={item.title} />
                ) : (
                    <PhotoCamera sx={{ color: '#ccc', fontSize: '2.5rem' }} />
                )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'hidden', p: 1 }}>
                <CardContent sx={{ flex: '1 0 auto', p: '8px !important' }}>
                    <Typography
                        onClick={(e) => { e.stopPropagation(); navigateToAd(); }}
                        component="div"
                        variant="h6"
                        sx={{ fontSize: '1rem', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', mb: 0.5 }}>
                        {item.title}
                    </Typography>
                    <Typography variant="subtitle1" color="text.secondary" component="div" sx={{ fontWeight: 'bold', mb: 1 }}>
                        {item.price} €
                    </Typography>
                    <Chip
                        label={item.status}
                        size="small"
                        sx={{ backgroundColor: getStatusClass(item.status), color: '#fff', fontWeight: 'bold', height: '24px' }}
                    />
                </CardContent>
                <Stack direction="row" spacing={0} sx={{ mt: 'auto', alignSelf: 'flex-start' }}>
                    {/* Zamenjamo gumb za urejanje z gumbom za ogled */}
                    <IconButton onClick={(e) => { e.stopPropagation(); navigateToAd(); }} size="small" aria-label="ogled" title="Poglej oglas">
                        <Visibility sx={{ color: "#14B8A6", fontSize: '1.25rem' }} />
                    </IconButton>
                    <IconButton onClick={(e) => { e.stopPropagation(); onDelete(); }} size="small" aria-label="izbriši" title="Odstrani iz priljubljenih">
                        <Delete sx={{ color: "red", fontSize: '1.25rem' }} />
                    </IconButton>
                </Stack>
            </Box>
        </Card>
    );
};

export default MobileFavoriteAdCard;